// extracted by mini-css-extract-plugin
export default {"add-account":"AddAccount_add-account__aMaxY"};